import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';

export default class DocumentMerge extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            types: props.Types,
            controllerName: 'document',
            loading: false,
            period: 1,
            fromDate: null,
            toDate: null,
            documentTypeId: this.getDefaultGuid()
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentDidMount() {
    }
    save(e) {
        if (this.isBlank(this.state.period)) this.state.period = 0;
        this.httpPost("api/v1/document/merge", {
            period: this.state.period,
            fromDate: this.convertMomentToDb(this.state.fromDate),
            toDate: this.convertMomentToDb(this.state.toDate),
            organizationId: window.organizationId,
            documentTypeId: this.state.documentTypeId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("تعداد " + data.count+" سند مرجع صادر گردید");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content" style={{ "width": "280px", "margin": "0 auto" }}>
                    <div className="modal-body" id="DocumentModalViewerContent">
                        <div className="panel panel-info center-block">
                            <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                                <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">تجمیع اسناد حسابداری</h4>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">از تاریخ</label>
                                            <div className="form-control-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => { this.state.fromDate = e }}
                                                    value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">تا تاریخ</label>
                                            <div className="form-control-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => { this.state.toDate = e }}
                                                    value={this.getFormatedDateForDatePicker(this.state.toDate)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">تعداد روز</label>
                                            <div className="form-control-wrap">
                                                <input onChange={e => this.state.period = parseInt(e.target.value)} defaultValue={this.state.period} autocomplete="off" type="text" className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="title1">نوع سند نهایی</label>
                                            <select defaultValue={this.state.documentTypeId} onChange={e => this.state.documentTypeId = e.target.value} className='form-control'>
                                                <option value={this.getDefaultGuid()}>انتخاب</option>
                                                {this.state.types.map(currency => <option value={currency.id}>{currency.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={e => this.save(e)}>اعمال</button>
                                <a className="btn btn-warning" onClick={e => this.closeMe()} > انصراف</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}